import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7L2 8.5C2 9.29565 2.31607 10.0587 2.87868 10.6213C3.44129 11.1839 4.20435 11.5 5 11.5H5.75V13L8.75 11.5H11C11.7956 11.5 12.5587 11.1839 13.1213 10.6213C13.6839 10.0587 14 9.29565 14 8.5V7C14 6.20435 13.6839 5.44129 13.1213 4.87868C12.5587 4.31607 11.7956 4 11 4ZM5.5325 8.2825C5.4097 8.40477 5.24836 8.48074 5.07589 8.4975C4.90341 8.51427 4.73046 8.4708 4.58641 8.37447C4.44236 8.27815 4.33612 8.13491 4.28573 7.96912C4.23534 7.80332 4.24391 7.62519 4.31 7.465C4.34798 7.37411 4.40125 7.2904 4.4675 7.2175C4.53722 7.1472 4.62017 7.09141 4.71157 7.05333C4.80296 7.01526 4.90099 6.99565 5 6.99565C5.09901 6.99565 5.19704 7.01526 5.28843 7.05333C5.37983 7.09141 5.46278 7.1472 5.5325 7.2175C5.60078 7.28883 5.6543 7.37294 5.69 7.465C5.74743 7.60158 5.76313 7.75212 5.7351 7.89761C5.70707 8.0431 5.63657 8.17703 5.5325 8.2825ZM8.5325 8.2825C8.4596 8.34875 8.37589 8.40202 8.285 8.44C8.1487 8.49456 7.99939 8.50791 7.85558 8.47841C7.71176 8.44891 7.57977 8.37785 7.47596 8.27404C7.37215 8.17023 7.30109 8.03824 7.27159 7.89442C7.24209 7.75061 7.25544 7.6013 7.31 7.465C7.34798 7.37411 7.40125 7.2904 7.4675 7.2175C7.53722 7.1472 7.62017 7.09141 7.71157 7.05333C7.80296 7.01526 7.90099 6.99565 8 6.99565C8.09901 6.99565 8.19704 7.01526 8.28843 7.05333C8.37983 7.09141 8.46278 7.1472 8.5325 7.2175C8.60078 7.28883 8.6543 7.37294 8.69 7.465C8.74743 7.60158 8.76313 7.75212 8.7351 7.89761C8.70707 8.0431 8.63657 8.17703 8.5325 8.2825ZM11.5325 8.2825C11.4097 8.40477 11.2484 8.48074 11.0759 8.4975C10.9034 8.51427 10.7305 8.4708 10.5864 8.37447C10.4424 8.27815 10.3361 8.13491 10.2857 7.96912C10.2353 7.80332 10.2439 7.62519 10.31 7.465C10.348 7.37411 10.4013 7.2904 10.4675 7.2175C10.5379 7.14805 10.6223 7.09436 10.715 7.06C10.8516 7.00257 11.0021 6.98687 11.1476 7.0149C11.2931 7.04293 11.427 7.11343 11.5325 7.2175C11.6008 7.28883 11.6543 7.37294 11.69 7.465C11.7474 7.60158 11.7631 7.75212 11.7351 7.89761C11.7071 8.0431 11.6366 8.17703 11.5325 8.2825Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
